export default __webpack_public_path__ + "static/media/vase.39f64a27.jpg";